import { DcBaseComponent } from '@deleteagency/dc';
import { deviceObserver } from '@deleteagency/device-observer';
import { DEVICE_TABLET } from 'general/js/app';

export default class SearchLayoutComponent extends DcBaseComponent {
    static getNamespace() {
        return 'search-layout';
    }

    static getRequiredRefs() {
        return ['meta', 'side', 'top'];
    }

    onInit() {
        this._onTheSide = true;
        this._check();
        deviceObserver.subscribeOnChange(this._check);
    }

    _check = () => {
        if (deviceObserver.is('<=', DEVICE_TABLET)) {
            if (this._onTheSide) {
                this._moveOnTop();
                this._onTheSide = false;
            }
        } else {
            if (!this._onTheSide) {
                this._moveToTheSide();
                this._onTheSide = true;
            }
        }
    };

    _moveToTheSide() {
        this.refs.side.insertAdjacentElement('afterbegin', this.refs.meta);
    }

    _moveOnTop() {
        this.refs.top.insertAdjacentElement('afterbegin', this.refs.meta);
    }
}
